import { getMap } from '../../atoms/map/utils/getMap'
import { findLayer } from '../utils/findLayer'

import { mapStylesUpdateTrafficAreaFeatures } from './utils/mapStylesUpdateTrafficAreaFeatures'

export function createUpdateTrafficAreaFeaturesMapStyleFromChangelog(
  markers: uui.domain.ui.map.markers.MapMarkers['trafficProfile'],
  mapStyles: uui.domain.ui.map.markers.MapStyles['trafficProfile'],
  selection: Set<string>,
) {
  // ATTENTION: Application of Map Style changes will not be cached if a delayed rendering mechanism will be implemented
  // After the whole set of delayed marker changelogs is applied a full refresh of Map Styles will be required

  return async () => {
    const map = getMap()
    const layer = findLayer(map, 'trafficProfile')

    // only the `update` field is populated in a mapStyles changelog
    for (const profileId in markers) {
      await mapStylesUpdateTrafficAreaFeatures(layer, markers[profileId], mapStyles, selection)
    }
  }
}
